import request from '@/utils/request'

// 获取省市区域集合(过滤失效地区)
export function listAllLevelArea(param) {
  return request({
    url: '/area/listAllLevelArea',
    method: 'get',
    params: param
  })
}
